import SingleSelectDropDownComponent from "../../../../_utils/CommonDropdown/SingleSelectDropdown";
import TitleSubtitlePair from "../../../../_utils/TitleSubtitlePair";

const UserGrade = ({
  userPayload,
  setUserPayload,
  gradeOption,
  previewMode = false,
}) => {
  if (previewMode) {
    return (
      <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
        <div className="text-text-primary font-semibold text-font-md">
          User Grade
        </div>
        <div className="flex flex-col gap-gap-sm">
          <TitleSubtitlePair
            title={userPayload.grade}
            titleColor="text-primary "
            subtitle={"Grade"}
            alignRight={false}
            hoverOption="white"
            isBold={false}
            variant="md"
          />
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col relative w-width-full mt-margin-md">
      <div className="py-padding-md bg-primary-card flex flex-col rounded-border-radius-md">
        <div className="w-width-full flex flex-col gap-gap-md">
          <div className="text-text-primary font-semibold text-base px-padding-md">
            User Grade
          </div>
        </div>
        <div className="px-padding-md pt-padding-md">
          <SingleSelectDropDownComponent
            type="big"
            options={gradeOption}
            selected={userPayload?.grade}
            setSelected={(val) => {
              setUserPayload({ ...userPayload, grade: val });
            }}
            showSearch={false}
            placeholder={"Select"}
          />
        </div>
      </div>
    </div>
  );
};

export default UserGrade;
